module.exports = __webpack_public_path__ + "img/logo.8db8ca8d.svg";